export default __webpack_public_path__ + "static/media/table-view-active.acf75f40.svg";